<script>
    import { Swiper } from "swiper";
    import { Navigation, Pagination } from "swiper/modules";
    import "swiper/css";
    import "swiper/css/navigation";
    import "swiper/css/pagination";
    import { onMount } from "svelte";

    export let slides = [];
    export let expParams = {};

    let swiper;
    let swiperInitialized = false;

    $: swiperParams = {
        modules: [Navigation, Pagination],
        grabCursor: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
            dynamicBullets: true,
        },
    };

    onMount(() => {
        try {
            swiper = new Swiper(".mySwiper", swiperParams);
            swiperInitialized = true;
        } catch (error) {
            console.error("Error initializing Swiper:", error);
        }
        return () => {
            if (swiperInitialized) swiper.destroy();
        };
    });
</script>

<div class="swiper mySwiper">
    <div class="swiper-wrapper">
        {#each slides as slide, index}
            <div class="swiper-slide">
                <img src={slide.image} alt={slide.title} />
                {#if index === slides.length - 1}
                    {#if expParams.buttonText && expParams.buttonLink}
                        <a href={expParams.buttonLink} class="button-link">
                            <div class="last-slide-button">
                                <button class="button"
                                    >{expParams.buttonText}</button
                                >
                            </div>
                        </a>
                    {/if}
                {/if}
            </div>
        {/each}
    </div>
    <div class="swiper-pagination"></div>
</div>

<style>
    .mySwiper {
        margin: 0 auto;
        position: relative;
        margin-bottom: 20px;
    }

    .swiper-slide {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        color: white;
        border-radius: 10px;
        position: relative; /* Добавлено для абсолютного позиционирования кнопки */
    }

    .swiper-slide img {
        object-fit: cover;
        border-radius: 10px;
        width: 100%;
        height: 100%;
    }

    .swiper-pagination {
        position: relative;
        margin-top: 20px;
    }

    :global(.swiper-pagination-bullet) {
        width: 10px;
        height: 10px;
        background-color: #4f7942;
    }

    .last-slide-button {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(
            -50%,
            -50%
        ); /* Центрирование относительно родителя */
    }

    .button {
        /* Стили для кнопки */
        padding: 10px 20px;
        background-color: #4f7942;
        color: white;
        border: none;
        border-radius: 5px;
        cursor: pointer;
    }
    .button-link {
        text-decoration: none; /* Убираем подчеркивание ссылки */
        color: inherit; /* Наследуем цвет из кнопки */
        display: inline-block; /* Важно для корректного отображения */
    }
    .button-link:hover {
        text-decoration: underline; /* Подчеркиваем при наведении */
    }
    .button-link:focus {
        outline: none; /* Убираем стандартный обводку при фокусе */
    }

    @media (min-width: 1280px) {
        .mySwiper {
            width: 50%;
        }
        .swiper-slide {
            height: 100vh;
        }
        .button {
            font-size: 25px;
        }
    }
    @media (max-width: 480px) {
        .mySwiper {
            width: 90%;
        }
        .swiper-slide {
            height: 80vh;
        }
        .last-slide-button {
            width: 100%;
            text-align: center;
        }
        .button {
            font-size: 15px;
        }
        :global(.swiper-pagination-bullet) {
            width: 7px;
            height: 7px;
        }
    }
    @media (min-width: 481px) and (max-width: 833px) {
        .mySwiper {
            width: 50%;
        }
        .swiper-slide {
            height: 100vh;
        }
        .last-slide-button {
            width: 100%;
            text-align: center;
        }
        .button {
            font-size: 15px;
        }
    }
    @media (min-width: 834px) and (max-width: 1023px) {
        .mySwiper {
            width: 90%;
        }
        .swiper-slide {
            height: 100vh;
        }
        .last-slide-button {
            width: 100%;
            text-align: center;
        }
        .button {
            font-size: 15px;
        }
    }
    @media (min-width: 1024px) and (max-width: 1279px) {
        .mySwiper {
            width: 90%;
        }
        .last-slide-button {
            width: 100%;
            text-align: center;
        }
        .button {
            font-size: 15px;
        }
    }
</style>
